export const EMAIL_LOGIN = 'EMAIL_LOGIN';
export const GOOGLE_LOGIN = 'GOOGLE_LOGIN';
export const FACEBOOK_LOGIN = 'FACEBOOK_LOGIN';
export const SIGN_UP = 'SIGN_UP';
export const FORGOT_PASSWORD = 'FORGOT_PASSWORD';
export const PASSWORD_RESET = 'PASSWORD_RESET';
export const PASSWORD_RESET_EMAIL = 'PASSWORD_RESET_EMAIL';
export const CHANGE_PASSWORD = 'CHANGE_PASSWORD';

export type AccountType = 'cook' | 'guest';
export interface Profile {
  firstName: string;
  lastName: string;
  email?: string;
  phoneNumber?: string;
  description?: string;
}

export interface CreateUserObject {
  firstName: string;
  lastName: string;
  email: string;
  password: string;
  confirmPassword?: string;
  status: string;
}

export interface EmailLoginCredentials {
  email: string;
  password: string;
}

export interface EmailLoginAction {
  type: typeof EMAIL_LOGIN;
  credentials: EmailLoginCredentials;
  accountType: AccountType;
}

export interface GoogleLoginAction {
  type: typeof GOOGLE_LOGIN;
  accountType: AccountType;
}

export interface FacebookLoginAction {
  type: typeof FACEBOOK_LOGIN;
  accountType: AccountType;
}

export interface SignUpAction {
  type: typeof SIGN_UP;
  accountType?: AccountType;
  user: CreateUserObject;
}

export interface PasswordResetEmail {
  type: typeof PASSWORD_RESET_EMAIL;
  email: string;
}

export interface ResetPassword {
  type: typeof PASSWORD_RESET;
  code: string;
  password: string;
}

export interface ChangePassword {
  type: typeof CHANGE_PASSWORD;
  email: string;
  currentpassword: string;
  newpassword: string;
}

export type AuthActionTypes =
  | EmailLoginAction
  | GoogleLoginAction
  | FacebookLoginAction
  | SignUpAction
  | ChangePassword;
